// extracted by mini-css-extract-plugin
module.exports = {"Layout":"styles_Layout__MHDWL","Footer":"styles_Footer__XAt_J","bgWrapper":"styles_bgWrapper__t44_y"};